// @ts-nocheck

import { RedirectServices, getRedirectUrl } from '../../../config/urls';
import { basketErrors } from '../constants';
import getMessageFromPayload from '../utils/getMessageFromPayload';

export const getValidatedValue = (body) => {
  const { b } = body;
  return parseFloat(b[0].o / 1000) || null;
};

export const getChangedValue = (body) => {
  const { edetails } = body;
  return parseFloat(edetails[Object.keys(edetails)[0]].einfo.o / 1000) || null;
};

export const getMinStake = (body) => {
  const { einfo } = body;
  if (einfo && einfo.min && einfo.min > 0) {
    return parseFloat(einfo.min / 100).toString();
  }
};

export const getMaxStake = (body) => {
  const { einfo } = body;
  if (einfo && einfo.max && einfo.max > 0) {
    return parseFloat(einfo.max / 100).toString();
  }
};

export default (body, actions) => {
  const { ecode, url, trid } = body;
  const message = getMessageFromPayload(body);

  // redirect because user limits are not registered
  if (url !== undefined) {
    actions.onError(message);
    actions.openExternalLink(getRedirectUrl(RedirectServices.ENCODED_URL, { url }), { auth: true });
    return;
  }

  switch (ecode) {
    case 0: {
      const validatedValue = getValidatedValue(body);
      actions.onValidated(message, { validatedValue });
      break;
    }
    case basketErrors.ERROR_CODE_AMOUNT_UNDER_LIMIT: {
      const newStake = getMinStake(body);
      actions.onError(message, { newStake });
      break;
    }
    case basketErrors.ERROR_CODE_NOT_ENOUGH_MONEY:
    case basketErrors.ERROR_CODE_AMOUNT_OVER_LIMIT: {
      const newStake = getMaxStake(body);
      actions.onError(message, { newStake });
      break;
    }
    case basketErrors.ERROR_CODE_ODDS_CHANGED: {
      const newValue = getChangedValue(body);
      actions.onError(message, { newValue });
      break;
    }
    case basketErrors.ERROR_CODE_TRADER: {
      const traderId = parseInt(trid, 10);
      actions.onWaitingTraderValidation(message, traderId);
      break;
    }
    default:
      actions.onError(message);
      break;
  }
};
